/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {ArchiveFileType} from './diplomat/enums/ArchiveFileType';
import {ArchiveTriggerType} from './diplomat/enums/ArchiveTriggerType';

export const ArchiveDefinition = yup.object({
   trigger: yup.string().oneOf(ArchiveTriggerType.keys),
   fileType: yup.string().oneOf(ArchiveFileType.keys),
   location: yup.string(),
   skip: yup.boolean(),
   skipPrimary: yup.boolean(),
   useTransaction: yup.boolean(),
   zip: yup.boolean(),
});
export type IArchiveDefinition = yup.InferType<typeof ArchiveDefinition>;
